import { useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';

const AutoLogout = () => {
  const navigate = useNavigate();
  
  // --- CONFIGURAZIONE ---
  // Dopo quanti minuti di inattività disconnettere?
  const TIMEOUT_MINUTES = 30; 
  const TIMEOUT_MS = TIMEOUT_MINUTES * 60 * 1000;

  useEffect(() => {
    let activityTimer;

    // Funzione che esegue il logout vero e proprio
    const performLogout = async () => {
      // Controlliamo prima se c'è una sessione attiva
      const { data: { session } } = await supabase.auth.getSession();
      
      if (session) {
        await supabase.auth.signOut();
        // Avviso l'utente (opzionale, ma gentile)
        alert("Per sicurezza, sei stato disconnesso per inattività.");
        // Rimando al login
        navigate('/login', { replace: true });
      }
    };

    // Funzione che "resetta" il timer ogni volta che l'utente fa qualcosa
    const resetTimer = () => {
      if (activityTimer) clearTimeout(activityTimer);
      activityTimer = setTimeout(performLogout, TIMEOUT_MS);
    };

    // Eventi da monitorare (se l'utente fa una di queste cose, è attivo)
    const events = [
      'mousedown',  // Click
      'mousemove',  // Muove il mouse
      'keydown',    // Scrive
      'scroll',     // Scorre la pagina
      'touchstart'  // Tocca lo schermo (mobile)
    ];

    // Attiviamo i "sensori"
    events.forEach(event => document.addEventListener(event, resetTimer));
    
    // Avviamo il timer appena si carica il sito
    resetTimer();

    // Pulizia (quando si chiude il sito)
    return () => {
      if (activityTimer) clearTimeout(activityTimer);
      events.forEach(event => document.removeEventListener(event, resetTimer));
    };
  }, [navigate, TIMEOUT_MS]);

  return null; // Componente invisibile
};

export default AutoLogout;